import Http from '../api/http';

export default class Option extends Http {
  constructor() {
    super();
  }

  /***********配置管理***************/
  /**
   * 查看配置列表
   * @param {string} type -  类型
   */
  option_getOptionList() {
    return super.post('option/getOptionList', ...arguments);
  }

  /**
   * 获取客服信息
   * @param taskId -任务id
   */
  option_getCustomerInfo() {
    return super.post('option/getCustomerInfo', ...arguments);
  }

  /**
   * 获取配置
   * @returns
   */
  option_getLastOptionVo() {
    return super.post('option/getLastOptionVo', ...arguments);
  }
}
